import MaterialIcon from "../../../../../MaterialIcon";
import React from "react";

export const InputDragHandle = () => {
    return (
        <div className="drag-handle">
            <MaterialIcon icon="drag_indicator" size={24}/>
        </div>
    )
}